import { Expo } from 'gsap';
import Preset from '../Preset';
import Rectangle from '../../graphics/Rectangle';

export default class Falling extends Preset {
  constructor(app) {
    super({ app, isFullScreen: true, requiresRootTransform: true });
    this.rectangles = [];
  }

  update(model) {
    super.update(model);

    const halfDuration = model.duration / 2;
    const sixthDuration = model.duration / 6;

    const { width } = this.root;

    // TODO: Parameters (should come from config object)
    // TODO: expand/shrink rectangle array if sections changes (old value != new)
    if (!this.sections) {
      this.sections = 11;
      this.buildSections();
    }
    const gap = 0.15;
    this.transitionDuration = halfDuration;
    this.sectionDuration = sixthDuration;

    // Always Calculated
    this.sectionWidth = width / this.sections;
    this.lastStartPos = this.transitionDuration - gap - this.sectionDuration;

    this.rectangles.forEach((rectangle, index) => {
      this.updateRectangle(rectangle, index);
      this.buildAnimation(rectangle, index);
    });
  }

  buildSections() {
    for (let x = 0; x < this.sections; x++) {
      this.rectangles.push(new Rectangle());
    }
  }

  updateRectangle = (rectangle, index) => {
    const { y, width } = this.root;

    // Initiate the rectangle in its starting positions
    rectangle.color = this.primaryColor.clone();
    rectangle.alpha = 0;
    rectangle.width = this.sectionWidth;
    rectangle.height = 0;
    rectangle.y = y;
    rectangle.x = index * this.sectionWidth - width / 2;
  };

  buildAnimation(rectangle, index) {
    // staggers the start times by giving a range 0 - 1
    const stagger = index / (this.sections - 1);

    // lastStartPos * 0 is the first, lastStartPos * 1 is the last
    const start = this.lastStartPos * stagger;

    this.animate(rectangle)
      .to(
        {
          alpha: this.primaryColor.getAlpha(),
          height: this.root.height,
          duration: this.sectionDuration,
          ease: Expo.easeOut,
        },
        start
      )
      .reverseOut();
  }

  render() {
    super.render();
    this.rectangles.forEach((rectangle) => rectangle.draw(this.graphics));
  }
}
